import { useState, useEffect } from 'react'
import '../styles.less'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import TotalBudgetWidgets from '../../../widgets/projectProposal/budget/TotalBudgetWidgets'
import ManagementFeeWidget from '../../../widgets/projectProposal/budget/ManagementFeeWidget'
import ContributionBudgetWidgets from '../../../widgets/projectProposal/budget/ContributionBudget/ContributionBudgetWidgets'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSummary, getProjectBudget } from '../../../redux/actions/budget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { Panel } from 'rsuite'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import pathname from '../../../constants/pathname'
import ActivityWidgets from '../../../widgets/projectProposal/budget/ActivityWidgets'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import ViewPreviousVersionButon from '../../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'

export default function Budget() {
  const [isEditWidget, setIsEditWidget] = useState({})
  // const [isEditAll, setIsEditAll] = useState(false)
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [summaryBudget, setSummaryBudget] = useState()
  const [showEditAll, setShowEditAll] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  const [summaryBudgetPrevious, setSummaryBudgetPrevious] = useState()

  // 🚩 เพิ่ม State สำหรับควบคุมการเปิด/ปิด โหมดเปรียบเทียบ
  const [isViewPrevious, setIsViewPrevious] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.projectManagementStructure}`,
    pathNameForward: `${pathname.proposal.objectiveGoal}`,
  }

  useEffect(() => {
    if (projectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectBudget(projectId)
      // console.log('__________schema ', _schema)

      setSummaryBudget(_schema?.forms?.summary)
      setSchema(_schema)
      doCalculateEditWidget(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSummary = async () => {
    try {
      console.log('handleGetSummary')
      const _schema = await getSummary(projectId)

      setSummaryBudget(_schema)
    } catch (e) {}
  }

  const handleGetActivity = async () => {
    console.log('handleGetActivity')
    handleSaveSucceed(true)
  }

  const doCalculateEditWidget = (_schema) => {
    let editObj = {
      activity: _schema?.forms?.activity?.value?.length > 0 ? false : true,
      // activity: _schema?.forms?.managementFee?.activity?.value > 0 ? false : true,
      other: _schema?.forms?.other?.value?.length > 0 ? false : true,
    }

    let managementFee = true

    _schema?.forms?.managementFee?.forEach((item, index) => {
      if (item.form.headerOnly) {
        item.subForms.forEach((subSchema, subIndex) => {
          editObj[`subForms_${subIndex}`] = subSchema?.values?.length > 0 ? false : true
          editObj[`activity_${subIndex}`] = subSchema?.activity?.value?.length > 0 ? false : true
          // let activity = schema?.forms?.activity && !schema.forms.activity.disabled
          // managementFee = managementFee && !subSchema.disabled
        })
      } else {
        editObj[`managementFeeWidget_${index}`] = item.form?.values?.length > 0 ? false : true
        // managementFee = managementFee && !item.form.disabled
      }
      managementFee = managementFee && !item.form.disabled
    })

    // let activity = schema?.forms?.activity && !schema.forms.activity.disabled
    let activity = schema?.forms?.activity && !schema?.forms?.activity.disabled
    let other = schema?.forms?.other && !schema.forms.other.disabled

    setIsEditWidget(editObj)
    setShowEditAll(activity && managementFee && other)
  }

  const handleSaveSucceed = async (bool) => {
    console.log('handleSaveSucceed ', bool)
    if (bool) {
      startLoading()
      try {
        const _schema = await getProjectBudget(projectId)
        console.log('_schema ', _schema)
        setSchema(_schema)
        setSummaryBudget(_schema?.forms?.summary)
        doCalculateEditWidget(_schema)
      } catch (e) {
        console.log('error', e)
        if (e?.response?.data) {
          setError({
            statusCode: e.response.data.status,
            errorMessage: e.response.data.errors?.message,
          })
        } else {
          setError({})
        }
      }
      doneLoading()
    }
  }

  // 🚩 ปรับระบบ Toggle สลับดูเวอร์ชันก่อนหน้า และแก้ Bug การดึงข้อมูล
  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }

      // 🚩 แก้ Bug: โค้ดเก่าดึง projectId ตอนนี้เปลี่ยนมาใช้ id ที่ถูกส่งมาจากปุ่มแทน
      const _schema = await getProjectBudget(id)

      // 🚩 แก้ Bug: โค้ดเก่า Set ทับ summaryBudget ของปัจจุบัน ตอนนี้เปลี่ยนเป็น summaryBudgetPrevious
      setSummaryBudgetPrevious(_schema?.forms?.summary)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)

      // ไม่ต้องเรียก doCalculateEditWidget สำหรับเวอร์ชันก่อนหน้าเพราะเราไม่ให้แก้ไขอยู่แล้ว
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  // 🚩 สกัดข้อมูลปัจจุบันออกมาเป็นก้อนเดียว เพื่อสลับ Panel ง่ายๆ
  const renderCurrentVersion = (
    <div className="top">
      {schema?.forms?.activity && (
        <>
          <ActivityWidgets
            showCommandButton={!schema.forms.activity.disabled}
            isEdit={isEditWidget.activity}
            schema={schema.forms.activity}
            activityBudgetValue={schema?.forms?.managementFee?.[0]?.subForms?.[0]?.values || []}
            saveSucceed={handleSaveSucceed}
            categoryType={1}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit(`activity`, _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}

      {schema?.forms?.managementFee && (
        <>
          <ManagementFeeWidget
            schema={schema?.forms?.managementFee}
            activityValue={schema?.forms?.activity?.value}
            getSummary={handleGetSummary}
            getActivity={handleGetActivity}
            handleOnChangeIsEdit={handleOnChangeIsEdit}
            setIsEditWidget={setIsEditWidget}
            isEditWidget={isEditWidget}
          />
          <br />
        </>
      )}

      {summaryBudget && (
        <>
          <TotalBudgetWidgets schema={summaryBudget} />
          <br />
        </>
      )}

      {schema?.forms?.other && (
        <>
          <ContributionBudgetWidgets
            showCommandButton={!schema.forms.other.disabled}
            isEdit={isEditWidget.other}
            schema={schema.forms.other}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('other', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}
    </div>
  )

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {/* 🚩 ส่งสถานะ toggle ไปให้ปุ่ม */}
        <ViewPreviousVersionButon
          handleGetSchemaPrevious={handleGetSchemaPrevious}
          isViewPrevious={isViewPrevious}
          masterSubjectId={'1-1018,1-1019,1-1020,1-1023,1-1024,5-5009'}
        />

        {/* 🚩 ย้ายปุ่ม Edit ออกมาด้านนอก Panel เหมือนหน้าอื่น */}
        {showEditAll && (
          <BtnEditAll
            onClickEditAll={getIsEditAll(isEditWidget)}
            routing={buttonRoute}
            hiddenBtnEdit={true}
            setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            editWidget={isEditWidget}
            forms={schema?.forms}
          />
        )}

        <div className="wrapper">
          {/* ==============================================
              ส่วนที่ 1: แสดงข้อมูลปัจจุบัน (ครอบ Panel เฉพาะตอนเปรียบเทียบ)
              ============================================== */}
          <div style={!isViewPrevious ? { width: '100%' } : {}}>
            {isViewPrevious ? (
              <Panel
                //classPrefix="view-version-panel"
                collapsible
                defaultExpanded
                shaded
                bordered
                header={'version ปัจจุบัน'}
                style={{ maxHeight: '550px', overflowY: 'auto', width: '100%' }}
              >
                {renderCurrentVersion}
              </Panel>
            ) : (
              renderCurrentVersion
            )}
          </div>

          {/* ==============================================
              ส่วนที่ 2: แสดงข้อมูลก่อนหน้า (ซ่อน/แสดง ตาม State)
              ============================================== */}
          {isViewPrevious && schemaPrevious && (
            <>
              <div className="line" />
              <div className="bottom">
                <Panel
                  collapsible
                  defaultExpanded
                  shaded
                  bordered
                  header={'version ก่อนหน้า'}
                  style={{
                    maxHeight: '550px',
                    overflowY: 'auto',
                    width: '100%',
                    backgroundColor: '#e4e4ed',
                  }}
                >
                  {schemaPrevious?.forms?.activity && (
                    <>
                      <ActivityWidgets
                        showCommandButton={false}
                        isEdit={false}
                        schema={schemaPrevious.forms.activity}
                        activityBudgetValue={
                          schemaPrevious?.forms?.managementFee?.[0]?.subForms?.[0]?.values || []
                        }
                        saveSucceed={() => {}} // 🚩 ปิดไม่ให้บันทึกข้อมูลทับจากเวอร์ชันเก่า
                      />
                      <br />
                    </>
                  )}

                  {schemaPrevious?.forms?.managementFee && (
                    <>
                      <ManagementFeeWidget
                        schema={schemaPrevious.forms.managementFee}
                        activityValue={schemaPrevious?.forms?.activity?.value}
                        isEdit={false}
                        getSummary={() => {}} // 🚩 ปิดการยิง API
                        getActivity={() => {}} // 🚩 ปิดการยิง API
                        setIsEditWidget={() => {}}
                        isEditWidget={false}
                      />
                      <br />
                    </>
                  )}

                  {summaryBudgetPrevious && (
                    <>
                      <TotalBudgetWidgets schema={summaryBudgetPrevious} />
                      <br />
                    </>
                  )}

                  {schemaPrevious?.forms?.other && (
                    <>
                      <ContributionBudgetWidgets
                        showCommandButton={false}
                        isEdit={false}
                        schema={schemaPrevious.forms.other}
                      />
                      <br />
                    </>
                  )}
                </Panel>
              </div>
            </>
          )}
        </div>
      </SidebarProposal>
    </>
  )
}
